const live_events = JSON.parse(localStorage.getItem('favLiveEvents'));

const state = {
  liveEvents: live_events ? live_events : [],
}
const getters = {
  getLiveEvents(state){
    return state.liveEvents
  },
}
const mutations = {
  ADD_LIVE_EVENT(state,val){
    if(!_.includes(state.liveEvents, val)){
      state.liveEvents.push(val)
    }else{
      var index = state.liveEvents.indexOf(val);
      if (index !== -1) {
        state.liveEvents.splice(index, 1);
      }
    }
  },
  REMOVE_LIVE_EVENT(state,val){
    var index = state.liveEvents.indexOf(val);
    if (index !== -1) {
      state.liveEvents.splice(index, 1);
    }
  },
}
const actions = {
  addToFavLive({ commit, state }, payload){
    commit('ADD_LIVE_EVENT', payload)
    localStorage.setItem('favLiveEvents', JSON.stringify(state.liveEvents));
  },
  removeToFavLive({ commit, state }, payload){
    commit('REMOVE_LIVE_EVENT', payload)
    localStorage.setItem('favLiveEvents', JSON.stringify(state.liveEvents));
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}